<template>
  <div id="pmlst">
    <selection-tool
      :loadingtext="loadingtext"
      :titlebar="titlebar"
      :errortext="errortext"
      :showtextpane="showtextpane"
    />
  </div>
</template>

<script>
import SelectionTool from '@/views/SelectionTool'

export default {
  name: 'app',
  components: { SelectionTool },
  data() {
    return {
      /**
       * Text for the loading screen.
       */
      loadingtext:
        'One moment, please. The Fleet® Product Selector is loading.',
      /**
       * The markup to use for the title inside the title bar.
       */
      titlebar: '<h1>Fleet® Product Selector</h1>',
      /**
       * The text to use if things go wrong and we end up in the error state.
       */
      errortext: "We're sorry, an error occurred. Please try again later.",
      /**
       * Should the questions show a text pane of supplemental information
       * while going through the question process.
       */
      showtextpane: false
    }
  }
}
</script>

<style lang="scss">
/**
 * This file holds configuration settings for use with the breakpoint
 * module for writing CSS.
 */
@import 'style/sass-config';
$lt_blue: #00aeef;
$dk_blue: #2671aa;
$green: #7eca25;
$dk_green: #008700;
$lt_grey: #c4afbf;
$grey: #666;
$divider: $lt_grey;
$text: $grey;
$link: $dk_blue;
$component_height: 400px;
/**
 * MOCK INHERITED DEFAULT STYLES
 */
html,
body {
  overflow-x: hidden;
}
.block.block-fleet-pmlst.block-selection-tool {
  border-top: 3px solid $lt_grey;
}
#page {
  padding: 0 !important;
}
#region-media {
  box-shadow: none !important;
}
#pmlst {
  margin: 0 auto;
  max-width: 75rem;
  @include breakpoint($mobile) {
    margin-top: -1rem;
  }
}
/**
 * END OF DEFAULTS
 */
.pmlst-main-wrapper {
  button {
    border-style: none;
    color: $text;
    cursor: pointer;
    font-size: 1rem;
    margin: 0;
    padding: 0;
    &:focus,
    &:hover,
    &:active {
      outline: none;
    }
  }
}

#pmlst-startup {
  background-color: $green;
  margin: 0 auto;
  min-height: $component_height;
  max-width: 600px;
  position: relative;
  * {
    color: #fff !important;
  }
  .image {
    background-image: url(./assets/intro-screen.png);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    height: 257px;
  }
  &:before,
  &:after {
    background-color: $green;
    background-repeat: no-repeat;
    bottom: 0;
    content: '';
    position: absolute;
    top: 0;
    width: 1000px;
    @include breakpoint($mobile) {
      background-image: none !important;
    }
  }
  &:before {
    background-image: url(./assets/bg-left.png);
    background-position: top right;
    right: 100%;
  }
  &:after {
    background-image: url(./assets/bg-right.png);
    background-position: top left;
    left: 100%;
  }

  .pmlst-startup-wrapper {
    font-size: 1.25rem !important;
    padding: 2rem 1rem;
    text-align: center;
    p {
      font-size: 1.25rem !important;
    }
  }
  button.start {
    background-color: $dk_blue;
    border: 1px solid $dk_blue;
    border-radius: 4rem;
    color: #fff;
    font-size: 1.25rem;
    padding: 1rem 2rem;
    text-transform: uppercase;
  }
}
#pmlst-questionlist {
  min-height: 280px;
  .pmlst-questionlist-wrapper {
    padding: 1rem;
    @include breakpoint(($tablet, $desktop)) {
      padding-top: 3rem;
    }
  }
}
#pmlst-quiz {
  margin: 0 auto;
  max-width: 800px;
  min-height: $component_height;
  text-align: left;
  button.back {
    border: 1px solid $lt_grey;
    border-radius: 0.5rem;
    padding: 0.5rem;
  }
  button.restart {
    border: 1px solid transparent;
    color: $dk_blue;
    padding: 0.5rem 0;
  }
  .actions {
    border-bottom: 1px solid $divider;
    padding: 1rem;
    @include breakpoint(($tablet, $desktop)) {
      position: relative;
      &:before,
      &:after {
        border-bottom: 1px solid $divider;
        bottom: -1px;
        content: '';
        position: absolute;
        top: -1px;
        width: 1000px;
      }
      &:before {
        right: 100%;
      }
      &:after {
        left: 100%;
      }
    }
  }
  .actions-wrapper {
    display: flex;
    & > div {
      flex: 1;
      &:first-child {
        text-align: left;
      }
      &:last-child {
        text-align: right;
      }
    }
    button {
      background-color: transparent;
    }
  }
}
// Question list
ol.pmlst-questionlist-list {
  list-style: none;
  margin: 0;
  padding: 0;
  & > li {
    display: none;
    margin: 0;
    padding: 0;
    &:last-child {
      display: block;
    }
  }
}
div.question-individual {
  button.response {
    background-color: transparent;
  }
  .qi-text {
    color: $dk_blue;
    font-size: 1.25rem;
    font-weight: bold;
    margin: 0 0 1rem;
  }
  .qi-options {
    margin: 0 0 1rem;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        margin: 0;
        padding: 0;
      }
    }
  }
  &.multiple-choice {
    button.response {
      padding-left: 2rem;
      position: relative;
      text-align: left;
      &:before {
        border: 2px solid $dk_blue;
        border-radius: 1rem;
        content: '';
        height: 1rem;
        left: 0;
        position: absolute;
        top: 0;
        width: 1rem;
      }
      &:hover,
      &:focus,
      &:active,
      &-active {
        &:before {
          background-color: $dk_blue;
        }
      }
    }
    .qi-options {
      ul li {
        display: block;
        margin-bottom: 1rem;
      }
    }
  }
  &.toggle {
    button.response {
      border: 1px solid $divider;
      border-radius: 0.5rem;
      margin-right: 0.5rem;
      padding: 0.5rem 1rem;
      &:hover,
      &:active,
      &:focus,
      &-active {
        background-color: $dk_blue;
        border-color: $dk_blue;
        color: #fff;
      }
    }
    .qi-options {
      ul li {
        display: inline-block;
      }
    }
  }
}

#pmlst-steptracker {
  padding: 1rem;
  text-align: center;
  .pmlst-steptracker-wrapper {
    @include breakpoint(($tablet, $desktop)) {
      padding-left: 50%;
      position: relative;
      z-index: 1;
    }
    &:before {
      background-image: url(./assets/logo.png);
      background-repeat: no-repeat;
      content: '';
      height: 85px;
      display: block;
      width: 330px;
      @include breakpoint($mobile) {
        margin: -1rem auto 1rem;
      }
      @include breakpoint(($tablet, $desktop)) {
        left: 25%;
        margin-left: -165px;
        position: absolute;
        top: -1rem;
        z-index: 2;
      }
    }
  }
  progress {
    background-color: #fff;
    border: 1px solid $lt_grey;
    border-radius: 0.25rem;
    display: block;
    height: 0.5rem;
    margin: 0 auto;
    overflow: hidden;
    width: 50%;
    -webkit-appearance: none;
    // Background...
    &::-webkit-progress-bar {
      background-color: #fff;
    }
    // Value/fill...
    // (browser specific per browser, cannot be combined)
    &::-webkit-progress-value {
      background-color: $dk_blue;
      border-radius: 0.25rem;
    }
    &::-moz-progress-bar {
      background-color: $dk_blue;
      border-radius: 0.25rem;
    }
    &::-ms-fill {
      background-color: $dk_blue;
      border-radius: 0.25rem;
    }
  }
}

#pmlst-outcome {
  background-color: $green;
  color: #fff;
  margin: 0 auto;
  min-height: $component_height;
  max-width: 800px;
  position: relative;
  &:before,
  &:after {
    background-color: $green;
    background-repeat: no-repeat;
    bottom: 0;
    content: '';
    position: absolute;
    top: 0;
    width: 1000px;
    @include breakpoint($mobile) {
      background-image: none !important;
    }
  }
  &:before {
    background-image: url(./assets/bg-left.png);
    background-position: top right;
    right: 100%;
  }
  &:after {
    background-image: url(./assets/bg-right.png);
    background-position: top left;
    left: 100%;
  }
  p {
    color: #fff !important;
  }
  .pmlst-outcome-wrapper {
    padding: 1rem;
  }
  a.button {
    background-color: transparent;
    border: 1px solid #fff;
    border-radius: 2rem;
    color: #fff;
    display: inline-block;
    font-size: 1rem;
    font-weight: bold;
    margin-right: 0.5rem;
    padding: 0.5rem 1rem;
    text-decoration: none;
    text-transform: uppercase;
    &:hover {
      background-color: transparent;
      color: #fff;
    }
    &.button-wtb {
      background-color: $dk_blue;
      border-color: $dk_blue;
    }
  }
  h3 {
    background-color: #fff;
    border-radius: 1rem;
    color: $dk_green;
    font-size: 1.25rem;
    margin: 1rem 0;
    padding: 0.5rem 1rem;
    i {
      color: $green;
      margin-right: 0.5rem;
    }
  }
  button {
    background-color: transparent;
    color: $dk_blue;
  }
  .actions {
    border-top: 1px solid #fff;
    display: flex;
    margin-top: 1rem;
    padding-top: 1rem;
    & > div {
      flex: 1;
      &:last-child {
        text-align: right;
      }
    }
  }
  .fleet-outcome {
    @include breakpoint($mobile) {
      .image {
        margin-bottom: 2rem;
        text-align: center;
      }
    }
    @include breakpoint(($tablet, $desktop)) {
      display: flex;
      padding: 2rem 0;
      & > div {
        box-sizing: border-box;
      }
      & > div.image {
        flex: 2;
        margin-right: 1rem;
        text-align: right;
      }
      & > div.text {
        flex: 3;
      }
    }
    img {
      height: auto;
      max-width: 100%;
    }
    .content {
      margin-bottom: 2rem;
    }
    .product-disclaimer {
      font-size: 0.75rem;
      margin-bottom: 2rem;
    }
  }
}

#pmlst-disclaimers {
  padding: 1rem;
  p {
    font-size: 0.9rem;
  }
}

// Transition applied to questions when they're added to the page...
.question-enter,
.question-leave-to {
  opacity: 0;
}
.question-enter-to,
.question-leave {
  opacity: 1;
}
.question-enter-active,
.question-leave-active {
  transition: opacity 0.5s ease;
}

// Transition applied to application state panes when changing on the page...
.pane-enter,
.pane-leave-to {
  opacity: 0;
}
.pane-enter-to,
.pane-leave {
  opacity: 1;
}
.pane-enter-active,
.pane-leave-active {
  transition: opacity 0.5s ease;
}

// Application loading animation
.pmlst-loader {
  .animation {
    border: 0.5rem solid $green;
    border-top: 0.5rem solid $dk_green;
    border-radius: 50%;
    margin: 2rem auto;
    width: 4rem;
    height: 4rem;
    animation: loaderanim 1s linear infinite;
  }
  .text {
    font-size: 0.75rem;
    margin-bottom: 2rem;
  }
}
@keyframes loaderanim {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
// end of application loading animation
</style>
